module.exports = __webpack_public_path__ + "static/cynthia-louise-square.90fcb99b.jpg";